import apiService from './api';
import { BillingHistoryResponse } from '../components/billing/billingTypes';

export interface BillingHistoryParams {
  billing_profile_id?: number;
  workspace_id?: number;
  type?: string;
  status?: string;
  from?: string;
  to?: string;
page?: number;
  limit?: number;
}

export interface CreditBreakdown {
  promotional_credits: number;
  refundable_credits: number;
  excess_payments: number;
  total: number;
}

export const billingApi = {
  // Get billing history with filters
  async getHistory(params: BillingHistoryParams = {}): Promise<BillingHistoryResponse> {
    const queryParams = new URLSearchParams();
    
    if (params.billing_profile_id) queryParams.append('billing_profile_id', params.billing_profile_id.toString());
    if (params.workspace_id) queryParams.append('workspace_id', params.workspace_id.toString());
    if (params.type) queryParams.append('type', params.type);
    if (params.status) queryParams.append('status', params.status);
    if (params.from) queryParams.append('from', params.from);
    if (params.to) queryParams.append('to', params.to);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    
    const query = queryParams.toString();
    const response = await apiService.get(`/billing/history${query ? `?${query}` : ''}`);
    return response.data;
  },
  
  // Get PDF download URL
  async getDownloadUrl(eventId: number): Promise<string> {
    const response = await apiService.get(`/billing/history/${eventId}/download`);
    return response.data.downloadUrl;
  },
  
  // Sync billing history from Chargebee
  async syncHistory(billingProfileId?: number): Promise<{ success: boolean; results: any[] }> {
    const response = await apiService.post('/billing/history/sync', {
      billing_profile_id: billingProfileId
    });
    return response.data;
  },
  
  // Get billing profiles (for filter dropdown)
  async getProfiles(): Promise<any[]> {
    const response = await apiService.get('/billing/profiles');
    return response.data.profiles || [];
  },
  
// Get credit balance breakdown for a billing profile (amounts in cents)
  async getProfileCredits(profileId: number): Promise<CreditBreakdown> {
    const response = await apiService.get(`/billing/profiles/${profileId}/credits`);
    return response.data;
  },

  // Get workspaces (for filter dropdown)
  async getWorkspaces(): Promise<any[]> {
    const response = await apiService.get('/workspaces');
    return response.data.workspaces || response.data || [];
  }
};

export default billingApi;
